export default "__VITE_ASSET__D6zf7LJr__"